import React from 'react';
import { Link } from 'react-router-dom';
import './ProductCard.css';

const ProductCard = ({ product }) => {
  const formatPrice = (price) => {
    if (!price) return 'Price not available';
    return `$${parseFloat(price).toFixed(2)}`;
  };

  const truncateDescription = (description, maxLength = 150) => {
    if (!description) return 'No description available';
    
    // Strip HTML tags for length calculation and display
    const stripHtml = (html) => {
      const tmp = document.createElement('div');
      tmp.innerHTML = html;
      return tmp.textContent || tmp.innerText || '';
    };
    
    const plainText = stripHtml(description);
    if (plainText.length <= maxLength) return plainText;
    return plainText.substring(0, maxLength) + '...';
  };

  return (
    <div className="product-card">
      <div className="product-card-header">
        <h3 className="product-title">
          <Link to={`/products/${product.id}`}>
            {product.product_name || 'Unnamed Product'}
          </Link>
        </h3>
        {product.name && (
          <p className="product-name">{product.name}</p>
        )}
        {product.brand && (
          <span className="product-brand-header">{product.brand}</span>
        )}
        <span className="product-sku">{product.sku}</span>
      </div>
      
      <div className="product-card-body">
        <p className="product-description">
          {truncateDescription(product.description)}
        </p>
        
        <div className="product-meta">
          {product.category && (
            <span className="product-category">{product.category}</span>
          )}
          {product.lifecycle && (
            <span className="product-lifecycle">{product.lifecycle}</span>
          )}
        </div>
      </div>
      
      <div className="product-card-footer">
        {product.price && (
          <span className="product-price">{formatPrice(product.price)}</span>
        )}
        <Link to={`/products/${product.id}`} className="view-details-btn">
          View Details
        </Link>
      </div>
    </div>
  );
};

export default ProductCard;
